import { useEffect, useState } from "react";
import defaultImage from "../../../../utils/DefaultImage";
import deleteIcon from "../../../../assets/admin/delete.svg";
import { RiArrowDownSLine } from "react-icons/ri";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

const OrderCart = (props) => {
  const {
    selectedAllwines,
    setSelectedAllwines,
    getB2bPriceForQuantity,
    handleQuantityChange,
  } = props;

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [dialog, setDialog] = useState(false);

  // const handleDeleteWine = (wineId) => {
  //     setSelectedAllwines(prev => prev.filter(wine => wine.id !== wineId));
  // };

  const handleDeleteWine = (wineId) => {
    setSelectedAllwines((prev) =>
      prev
        .filter((wine) => wine.id !== wineId)
        .map((wine, idx) => ({ ...wine, sr_no: idx + 1 }))
    );
  };

  // const [showOption, setShowOption] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // Add this effect to close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest('.relative')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <>
      <h1 className="text-xl font-bold mb-1 poppins-medium  self-start">
        Dettaglio Ordine
      </h1>
      <div className=" wine-main-table w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
        <table className="w-full text-left wine_table">
          <thead>
            <tr className="border-b border-[#8B2433]">
              <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                Sr.no
              </th>
              <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                Immagine
              </th>
              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Nome
              </th>

              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Codice
              </th>

              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Prezzo No IVA
              </th>

              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                IVA%
              </th>

              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Quantità
              </th>
              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Prezzo totole
              </th>
              <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                Opzioni
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedAllwines?.length > 0 ? (
              selectedAllwines.map((wine, index) => {
                return (
                  <tr
                    key={index}
                    className="border-b border-[#8B2433]/12 text-sm"
                  >
                    <td className="py-4 text-left poppins-regular">
                      {/* {index + 1} */}
                      {wine.sr_no}
                    </td>
                    <td className="pr-2 py-4">
                      <div className="relative thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                        <img
                          className="w-[100px] h-100 object-contain border border-[#68172394] rounded-lg p-1"
                          src={
                            wine?.image && wine?.image !== ""
                              ? wine?.image
                              : defaultImage
                          }
                        />
                      </div>
                    </td>
                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      {wine?.name || "N/A"}
                    </td>
                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      {wine?.reference || "N/A"}
                    </td>
                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      {getB2bPriceForQuantity(wine?.meta, wine.quantity ?? 0)}
                    </td>
                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      22%
                    </td>
                    {/* <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                                                <input
                                                    type="text"
                                                    name="quantity"
                                                    value={wine.quantity === 0 ? "" : wine.quantity ?? ""}
                                                    onChange={(e) => handleQuantityChange(wine.id, e.target.value)}
                                                    disabled={!wine?.meta || wine?.meta?.length === 0}
                                                    className={`border-[3px] px-2 py-1 w-[40%] rounded-xl w-[60%]
                                ${!wine?.meta || wine?.meta?.length === 0 ? "cursor-not-allowed bg-gray" : "border-[#303030]"}`}
                                                />
                                            </td> */}

                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      {/* <div className="flex items-center"> */}
                      {/* <div className="flex flex-col w-full space-y-3 dropdown-container">
                                                        <div className="relative group w-full">
                                                            <button
                                                                className={`${showOption ? "border-b-0 rounded-tl-3xl rounded-tr-3xl" : "rounded-full"} border bg-[#fff] font-medium border-[#d5d6d9] inline-flex justify-between items-center w-full px-4 py-[8px] outline-none text-[#6B6B6B] shadow-sm relative z-30 text-xs`}
                                                                onClick={() => setShowOption(!showOption)}
                                                                disabled={!wine?.meta || wine?.meta?.length === 0}
                                                            >
                                                                <span className="mr-2 flex items-center gap-3 poppins-medium">
                                                                    Select Quantity
                                                                </span>
                                                                <RiArrowDownSLine
                                                                    className={`transform transition-transform duration-300 ${showOption ? "rotate-180" : ""} ${!wine?.meta || wine?.meta?.length === 0 ? "opacity-50" : ""}`}
                                                                    size={"24px"}
                                                                    color="#9f414f"
                                                                />
                                                            </button>
                                                            {showOption && (
                                                                <div
                                                                    className="bg-[#FFFFFF] opacity-100 z-50 border-[#d5d6d9] absolute pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full border"
                                                                >
                                                                    <div className="max-h-[130px] overflow-y-auto btn-all-yscroll">
                                                                        {(() => {
                                                                            // Extract the multiplier from the product code
                                                                            const codeParts = wine.reference?.split('-') || [];
                                                                            const multiplier = parseInt(codeParts[codeParts.length - 1]) || 1;

                                                                            // Generate the options
                                                                            const options = [];
                                                                            // Add default "Select" option
                                                                            options.push(
                                                                                <div
                                                                                    className="flex gap-[20px]"
                                                                                    key="select-default"
                                                                                    onClick={() => {
                                                                                        handleQuantityChange(wine.id, "");
                                                                                        setShowOption(!showOption);
                                                                                    }}
                                                                                >
                                                                                    <label className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn w-full">
                                                                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                                                                            Select
                                                                                        </span>
                                                                                    </label>
                                                                                </div>
                                                                            );

                                                                            // Add quantity options
                                                                            for (let i = 1; i <= 4; i++) {
                                                                                const value = multiplier * i;
                                                                                options.push(
                                                                                    <div
                                                                                        className="flex gap-[20px]"
                                                                                        key={`quantity-${i}`}
                                                                                        onClick={() => {
                                                                                            handleQuantityChange(wine.id, value.toString());
                                                                                            setShowOption(!showOption);
                                                                                        }}
                                                                                    >
                                                                                        <label className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn w-full">
                                                                                            <span className="text-xs text-[#8B8B8B] rounded-md flex items-center poppins-regular">
                                                                                                {value}
                                                                                            </span>
                                                                                        </label>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return options;
                                                                        })()}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div> */}

                      {/* <Menu>
                                                    <MenuButton
                                                        disabled={!wine?.meta || wine?.meta?.length === 0}
                                                        className={`flex items-center justify-center gap-2 border-[3px] px-3 py-1 rounded-xl mr-2 text-xs poppins-medium min-w-[80px] ${!wine?.meta || wine?.meta?.length === 0
                                                            ? "cursor-not-allowed bg-gray-100 text-gray-400"
                                                            : "border-[#303030] cursor-pointer hover:bg-gray-50 transition-colors"
                                                            }`}
                                                    >
                                                        <span className="mx-auto">Select</span>
                                                        <RiArrowDownSLine size={16} className="text-gray-500" />
                                                    </MenuButton>

                                                    <MenuItems
                                                        anchor="bottom"
                                                        className="bg-white px-3 py-2 mt-1 w-[100px] text-black flex flex-col gap-1 shadow-lg rounded-xl relative border border-gray-100"
                                                    >
                                                        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>

                                                        {(() => {
                                                            const codeParts = wine.reference?.split('-') || [];
                                                            const multiplier = parseInt(codeParts[codeParts.length - 1]) || 1;
                                                            const options = [];

                                                            for (let i = 1; i <= 4; i++) {
                                                                const value = multiplier * i;
                                                                options.push(
                                                                    <MenuItem key={i}>
                                                                        <button
                                                                            onClick={() => handleQuantityChange(wine.id, String(value))}
                                                                            className="w-full py-1.5 text-center rounded-md text-gray-700 hover:bg-[#8b2433]/10 hover:text-[#8b2433]"
                                                                        >
                                                                            {value}
                                                                        </button>
                                                                    </MenuItem>
                                                                );
                                                            }
                                                            return options;
                                                        })()}
                                                    </MenuItems>
                                                </Menu> */}

                      {/* <Menu>
                        <MenuButton
                          disabled={!wine?.meta || wine?.meta?.length === 0}
                          className={` group flex items-center justify-center text-[#DB7685] gap-2 border-[1.5px] border-[#d18d97] px-3 py-2 rounded-xl text-xs poppins-medium min-w-[90px] focus:outline-none focus-visible:outline-none ${
                            !wine?.meta || wine?.meta?.length === 0
                              ? "cursor-not-allowed bg-gray-100 text-gray-400"
                              : "border-[#303030] cursor-pointer hover:bg-gray-50 transition-colors"
                            }`}
                        >

                          <input
                            type="text"
                            name="quantity"
                            value={
                              wine.quantity === 0
                                ? "Select"
                                : wine.quantity ?? "Select"
                            }
                            onChange={(e) =>
                              handleQuantityChange(wine.id, e.target.value)
                            }
                            disabled={!wine?.meta || wine?.meta?.length === 0}
                            className={`w-12 text-sm  focus:outline-none focus-visible:outline-none  ${
                              !wine?.meta || wine?.meta?.length === 0
                                ? "cursor-not-allowed"
                                : ""
                              }`}
                          />
                          <RiArrowDownSLine
                            className="transform transition-transform duration-300 group-aria-expanded:rotate-180"
                            size={"20px"}
                          />
                        </MenuButton>

                        <MenuItems
                          anchor="bottom"
                          className="bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col  shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden mt-1"
                        >
                          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>

                          {(() => {
                            const codeParts = wine.reference?.split("-") || [];
                            const multiplier =
                              parseInt(codeParts[codeParts.length - 1]) || 1;
                            const options = [];

                            for (let i = 1; i <= 4; i++) {
                              const value = multiplier * i;
                              options.push(
                                <MenuItem key={i}>
                                  <button
                                    onClick={() =>
                                      handleQuantityChange(
                                        wine.id,
                                        String(value)
                                      )
                                    }
                                    className="w-full text-sm flex gap-2 justify-center items-center poppins-regular px-3 py-[5px] hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out"
                                  >
                                    {value}
                                  </button>
                                </MenuItem>
                              );
                            }
                            return options;
                          })()}
                        </MenuItems>
                      </Menu> */}

                      <div
                        className={`w-[100px] relative group flex items-center justify-center text-[#DB7685] gap-2 border-[1.5px] border-[#d18d97] px-3 py-2 rounded-xl text-xs poppins-medium  ${!wine?.meta || wine?.meta?.length === 0
                          ? "cursor-not-allowed bg-gray-100 text-gray-400"
                          : "border-[#303030] cursor-pointer hover:bg-gray-50 transition-colors"
                          }`}
                      >
                        <input
                          type="text"
                          name="quantity"
                          value={
                            wine.quantity === 0
                              ? "Select"
                              : wine.quantity ?? "Select"
                          }
                          onChange={(e) =>
                            handleQuantityChange(wine.id, e.target.value)
                          }
                          disabled={!wine?.meta || wine?.meta?.length === 0}
                          className={`absolute left-[20px] w-12 text-sm focus:outline-none ${!wine?.meta || wine?.meta?.length === 0
                            ? "cursor-not-allowed"
                            : ""
                            }`}
                        />

                        <Menu>
                          <div>
                            <MenuButton className="menu-icon min-w-[90px] text-right"
                              disabled={!wine?.meta || wine?.meta?.length === 0}
                            >
                              <RiArrowDownSLine
                                className="transform transition-transform duration-300 group-aria-expanded:rotate-180 absolute right-0 top-1/2 translate-y-[-50%] mr-[5px]"
                                size={"20px"}
                              />
                            </MenuButton>
                          </div>

                          <MenuItems
                            anchor="bottom"
                            className="mt-4 bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                          >
                            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>

                            {(() => {
                              const codeParts =
                                wine.reference?.split("-") || [];
                              const multiplier =
                                parseInt(codeParts[codeParts.length - 1]) || 1;
                              const options = [];

                              for (let i = 1; i <= 4; i++) {
                                const value = multiplier * i;
                                options.push(
                                  <MenuItem key={i}>
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          wine.id,
                                          String(value)
                                        )
                                      }
                                      className="w-full text-sm flex gap-2 justify-center items-center poppins-regular px-3 py-[5px] hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out"
                                    >
                                      {value}
                                    </button>
                                  </MenuItem>
                                );
                              }
                              return options;
                            })()}
                          </MenuItems>
                        </Menu>
                      </div>

                      {/* <div className="relative">
                        <div
                          className={`group flex items-center justify-center text-[#DB7685] gap-2 border-[1.5px] border-[#d18d97] px-3 py-2 rounded-xl text-xs poppins-medium min-w-[90px] ${!wine?.meta || wine?.meta?.length === 0
                            ? "cursor-not-allowed bg-gray-100 text-gray-400"
                            : "border-[#303030] cursor-pointer hover:bg-gray-50 transition-colors"
                            }`}
                        >
                          <input
                            type="text"
                            name="quantity"
                            value={wine.quantity === 0 ? "Select" : wine.quantity ?? "Select"}
                            onChange={(e) => handleQuantityChange(wine.id, e.target.value)}
                            disabled={!wine?.meta || wine?.meta?.length === 0}
                            className={`w-12 text-sm focus:outline-none ${!wine?.meta || wine?.meta?.length === 0 ? "cursor-not-allowed" : ""
                              }`}
                          />
                          <button
                            onClick={(e) => {
                              if (wine?.meta && wine.meta.length > 0) {
                                e.stopPropagation();
                                setIsDropdownOpen(!isDropdownOpen);
                              }
                            }}
                            disabled={!wine?.meta || wine?.meta?.length === 0}
                            className="transform transition-transform duration-300 group-aria-expanded:rotate-180"
                          >
                            <RiArrowDownSLine size={"20px"} />
                          </button>
                        </div>

                        {isDropdownOpen && (
                          <div className="absolute z-10 bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col shadow-2xl rounded-xl mt-1">
                            <div className="absolute -top-2 right-4 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>

                            {(() => {
                              const codeParts = wine.reference?.split("-") || [];
                              const multiplier = parseInt(codeParts[codeParts.length - 1]) || 1;
                              const options = [];

                              for (let i = 1; i <= 4; i++) {
                                const value = multiplier * i;
                                options.push(
                                  <button
                                    key={i}
                                    onClick={() => {
                                      handleQuantityChange(wine.id, String(value));
                                      setIsDropdownOpen(false);
                                    }}
                                    className="w-full text-sm flex gap-2 justify-center items-center poppins-regular px-3 py-[5px] hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out"
                                  >
                                    {value}
                                  </button>
                                );
                              }
                              return options;
                            })()}
                          </div>
                        )}
                      </div> */}

                      {/* <select
                                                        value=""
                                                        onChange={(e) => {
                                                            if (e.target.value) {
                                                                handleQuantityChange(wine.id, e.target.value);
                                                            }
                                                        }}
                                                        disabled={!wine?.meta || wine?.meta?.length === 0}
                                                        className={`border-[3px] px-2 py-1 rounded-xl mr-2 ${!wine?.meta || wine?.meta?.length === 0
                                                                ? "cursor-not-allowed bg-gray"
                                                                : "border-[#303030]"
                                                            }`}
                                                    >
                                                        <option value="">Select</option>
                                                        {(() => {
                                                            // Extract the multiplier from the product code
                                                            const codeParts = wine.reference?.split('-') || [];
                                                            const multiplier = parseInt(codeParts[codeParts.length - 1]) || 1;

                                                            // Generate the 4 options
                                                            const options = [];
                                                            for (let i = 1; i <= 4; i++) {
                                                                const value = multiplier * i;
                                                                options.push(
                                                                    <option key={i} value={value}>
                                                                        {value}
                                                                    </option>
                                                                );
                                                            }
                                                            return options;
                                                        })()}
                                                    </select> */}
                      {/* <input
                                                        type="text"
                                                        name="quantity"
                                                        value={wine.quantity === 0 ? "" : wine.quantity ?? ""}
                                                        onChange={(e) => handleQuantityChange(wine.id, e.target.value)}
                                                        disabled={!wine?.meta || wine?.meta?.length === 0}
                                                        className={`border-[3px] px-2 py-1 rounded-xl w-[60%] ${!wine?.meta || wine?.meta?.length === 0
                                                                ? "cursor-not-allowed bg-gray"
                                                                : "border-[#303030]"
                                                            }`}
                                                    /> */}
                      {/* </div> */}
                    </td>

                    <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                      {(() => {
                        const quantity = parseInt(wine.quantity) || 0;
                        const servedPrice =
                          parseFloat(
                            getB2bPriceForQuantity(wine.meta, quantity)
                          ) || 0;
                        const basePrice = servedPrice * quantity;
                        const taxAmount = basePrice * 0.22;
                        const finalPrice = basePrice + taxAmount;
                        return `${finalPrice.toFixed(2)} €`;
                      })()}
                    </td>

                    <td className="py-4 px-2">
                      <button
                        className="mx-2 text-red-700"
                        onClick={() => {
                          setDialog(true);
                          setSelectedOrderId(wine.id);
                        }}
                      >
                        <img
                          src={deleteIcon}
                          alt="Delete"
                          height={13}
                          width={13}
                        />
                      </button>
                      {dialog && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-20 z-50">
                          <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                            <div className="px-6 py-4 border-b">
                              <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                Are you sure you want to delete the order cart?
                              </h3>
                            </div>
                            <div className="px-6 py-4 flex justify-end space-x-4">
                              <button
                                onClick={() => {
                                  handleDeleteWine(selectedOrderId);
                                  setDialog(false);
                                }}
                                className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                              >
                                Yes
                              </button>
                              <button
                                onClick={() => setDialog(false)}
                                className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={9} className="text-center py-4">
                  No wines found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrderCart;
